module.exports = __webpack_public_path__ + "img/cart-off.fe2c0aef.png";